import React, { useRef, useState } from 'react';
import cs from 'classnames';
import { faLink } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { intl } from 'shared/lib/intl';
import Tooltip from 'shared/components/atoms/Tooltip/NewTooltip';
import { BUTTON_VARIANTS } from 'shared/styles/button';
import { Button } from 'shared/components/display';
import { copyToClipboard } from 'shared/utilities/stringUtility';

import styles, { ANIMATION_DURATION } from './styles';
import { Placement } from '@floating-ui/react';

type Props = {
  text: string;
  link: string;
  size?: 'xs' | 'sm' | 'lg';
  dataCy?: string;
  className?: string;
  tooltipPlacement?: Placement;
  portalTarget?: string | HTMLElement | null;
  copiedText?: string;
};

const LINK_COPIED = intl.formatMessage({ id: 'BUTTON_LINK_COPIED' });

const CopyLink: React.FC<Props> = ({
  link,
  text: textProp,
  dataCy,
  size = 'sm',
  className,
  tooltipPlacement,
  portalTarget,
  copiedText,
}) => {
  const [text, setText] = useState(textProp);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const handleClick = () => {
    copyToClipboard(link);
    setText(copiedText || LINK_COPIED);
    setTimeout(() => setText(textProp), ANIMATION_DURATION);
  };

  return (
    <Tooltip content={text} placement={tooltipPlacement} portalTarget={portalTarget}>
      <Button
        css={styles}
        className={cs('copy-link', className)}
        onClick={handleClick}
        ref={buttonRef}
        data-cy={dataCy}
        variant={BUTTON_VARIANTS.TEXT_ONLY}
      >
        <FontAwesomeIcon icon={faLink} size={size} />
      </Button>
    </Tooltip>
  );
};

export default CopyLink;
